import { Avatar, Dialog, DialogContent, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, ListSubheader, Button as MuiButton } from "@material-ui/core";
import { Delete, Person, RateReview } from "@material-ui/icons";
import axios from "axios";
import RichTextInput from "ra-input-rich-text";
import { useContext, useState } from "react";
import { BooleanInput, Button, NumberInput, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, useNotify, useRefresh } from "react-admin";
import { Spacer } from "../../components/spacer";
import { AppContext } from "../../providers/app-context-provider/app.context";
import cookiesProvider from "../../providers/cookies-provider";
import { getApiUrl } from "../../utils/urls";

const EvaluateButton = ({ record, ...props }) => {
    const apiUrl = getApiUrl();
    const notify = useNotify()
    const context = useContext(AppContext)

    const refresh = useRefresh()

    const [dialogOpen, setDialogOpen] = useState(false)
    const fields = {
        grade: record.workload ? record.workload : record?.type?.reference_workload,
        finalize: false,
        teacher_observations: ''
    };

    const validateRequired = [required("Campo obrigatório")]
    const canEvaluate = record?.process?.managed_by?.find(manager => manager.user.id === context.currentUser.id);
    const evaluated = (record?.workload || record?.teacher_observations);
    const reference_workload = record?.type?.reference_workload;


    const openDialog = () => setDialogOpen(true)
    const closeDialog = () => setDialogOpen(false);

    const translateWorkload = (w) => {
        if (w === 'G') return 'Nota'
        else if (w === 'T') return 'Carga horária'
        else if (w === 'C') return 'Cumprimento de tarefa'
    }

    const handleSubmit = async (values) => {
        const token = cookiesProvider.getToken();
        await axios.post(`${apiUrl}/activities/${record.id}/evaluate`,
            { id: values.id, grade: values.grade, teacher_observations: values.teacher_observations, finalize: values.finalize },
            { headers: { "Authorization": token } })
            .then(response => {
                if (response.status === 500) {
                    notify('Erro', 'error')
                } else {
                    notify('Avaliação realizada com sucesso', 'success')
                    refresh()
                }
            })
            .catch((error) => {
                notify(error, 'error')
            });
        setDialogOpen(false);
    }

    const handleUndo = async () => {
        const token = cookiesProvider.getToken();
        await axios.get(`${apiUrl}/activities/${record.id}/undoEvaluate`,
            { headers: { "Authorization": token } })
            .then(response => {
                if (response.status === 500) {
                    notify('Erro', 'error')
                } else {
                    notify('Avaliação desfeita com sucesso', 'success')
                    refresh()
                }
            })
            .catch((error) => {
                notify(error, 'error')
            });
        setDialogOpen(false);
    }

    const ToolbarForm = (props) => {
        return <Toolbar {...props} >
            <MuiButton
                style={{ marginLeft: '5px' }}
                variant={'contained'}
                onClick={closeDialog}
                size={'small'}>
                Cancelar
            </MuiButton>
            <Spacer />
            <MuiButton
                style={{ marginRight: '5px' }}
                variant={'contained'}
                startIcon={<Delete />}
                disabled={!evaluated}
                onClick={handleUndo}
                size={'small'}>
                Desfazer avaliação
            </MuiButton>
            <SaveButton
                label="Salvar"
                submitOnEnter={false}
                onSave={(values) => handleSubmit(values)}
                size={'small'}
            />
        </Toolbar>
    }

    const choices = [{ id: 'ct', name: 'Cumpriu totalmente' }, { id: 'cp', name: 'Cumpriu parcialmente' }, { id: 'nc', name: 'Não cumpriu' }]

    const numericGrade = (() => {
        if (record?.grade == null) return undefined;
        const value = parseFloat(
            String(record.grade).trim().replace(',', '.')
        );
        return Number.isFinite(value) ? value : undefined;
    })();

    return (
        <>
            {
                canEvaluate && <Button
                    startIcon={<RateReview />}
                    size='small'
                    label={evaluated ? "Revisar avaliação" : "Avaliar"}
                    onClick={openDialog}
                />
            }
            <Dialog open={dialogOpen} onClose={closeDialog} fullWidth>
                <DialogTitle> {evaluated ? "Revisar avaliação" : "Avaliar movimentação"} </DialogTitle>
                <DialogContent dividers>
                    <List dense={true} subheader={<ListSubheader disableSticky>Alunos</ListSubheader>}>
                        {record.students?.map((student, index) => {
                            return (
                                <ListItem key={index}>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <Person />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={student.user.name}
                                        secondary={student.user.email}
                                    />
                                </ListItem>
                            )
                        })}
                    </List>
                    <SimpleForm toolbar={<ToolbarForm />} initialValues={fields}>
                        {

                            record?.type?.workload_type === 'G' &&
                            <NumberInput
                                source='grade'
                                label={translateWorkload(record?.type?.workload_type)}
                                defaultValue={numericGrade}
                                validate={validateRequired}
                                fullWidth
                            />
                        }
                        {
                            record?.type?.workload_type === 'T' &&
                            <TextInput
                                source='grade'
                                label={translateWorkload(record?.type?.workload_type)}
                                defaultValue={reference_workload}
                                validate={validateRequired}
                                fullWidth
                            />
                        }

                        {
                            record?.type?.workload_type === 'C' &&
                            <SelectInput
                                source='grade'
                                label='Nota'
                                choices={choices}
                                value={record.workload}
                                optionText='name'
                                validate={validateRequired}
                                fullWidth
                            />
                        }

                        <RichTextInput
                            source='teacher_observations'
                            label='Observações'
                            fullWidth
                        />

                        {
                            !record.evaluated &&
                            <BooleanInput
                                source='finalize'
                                label='Finalizar movimentação após correção'
                                fullWidth
                            />
                        }
                    </SimpleForm>
                </DialogContent>
            </Dialog>
        </>
    )
}


export default EvaluateButton